import { View } from 'tamagui'

export function PathContinueSection() {
  const skip = true
  // TODO: Implementação do componente no futuro, priorizando entrega rápida do app
  if (skip) return null
  return <View />
}
